import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const GoogleOAuthCallback = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { setUserFromToken } = useAuth();
    const [error, setError] = useState("");

    useEffect(() => {
        const handleCallback = async () => {
            const token = searchParams.get("token");
            const errorParam = searchParams.get("error");

            if (errorParam) {
                setError(decodeURIComponent(errorParam));
                // Redirect to signin after showing error
                setTimeout(() => {
                    navigate("/signin");
                }, 3000);
                return;
            }

            if (token) {
                try {
                    // Store token
                    localStorage.setItem("token", token);

                    // Decode token and set user from token
                    setUserFromToken(token);

                    // Navigate to dashboard
                    navigate("/dashboard");
                } catch (err) {
                    setError("Failed to process authentication");
                    setTimeout(() => {
                        navigate("/signin");
                    }, 3000);
                }
            } else {
                setError("No authentication token received");
                setTimeout(() => {
                    navigate("/signin");
                }, 3000);
            }
        };

        handleCallback();
    }, [searchParams, navigate, setUserFromToken]);

    if (error) {
        return (
            <div className="w-full relative bg-base-100 overflow-hidden flex flex-col items-center justify-center min-h-screen">
                <div className="max-w-md w-full space-y-8 text-center">
                    <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-error/20 mb-4">
                        <svg className="h-8 w-8 text-error" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </div>
                    <h1 className="text-2xl font-bold text-base-content">
                        Authentication Failed
                    </h1>
                    <p className="text-base-content/70">{error}</p>
                    <p className="text-sm text-base-content/60">Redirecting to sign in...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="w-full relative bg-base-100 overflow-hidden flex flex-col items-center justify-center min-h-screen">
            <span className="loading loading-spinner loading-lg"></span>
            <p className="mt-4 text-base-content/70">Completing Google sign in...</p>
        </div>
    );
};

export default GoogleOAuthCallback;
